import React from "react"
import {
  ListItem,
  Text,
  Image,
} from "."
import {
  Button as MuiButton,
  Box as MuiBox,
  Badge as MuiBadge,
} from "@material-ui/core"
import useStyles from './styles'

const _CardMedia = ({media, width, aspectRatio, selected}) => {
  return (
    <div style={{
        width: width || '10rem',
        flexShrink: 0
      }}
      >
      <Image src={media} aspectRatio={aspectRatio} />
    </div>
  )
}

const _CardTitle = ({primary, textPrimaryColor, secondary, maxLine=1, selected, textCustomPropsSecondary={}}) => {
  return (
    <MuiBox display='flex' alignItems='baseline'>
      <MuiBox flexGrow={1}>
        <Text 
          style={{ fontWeight: 700 }} 
          color={selected ? 
            "textPrimaryContrast" : 
            typeof textPrimaryColor !== 'undefined' ? textPrimaryColor : "textPrimary"
          }
          maxLine={maxLine}>
          {primary}
        </Text>
      </MuiBox>
      {secondary &&
        <MuiBox>
          <Text
            variant="body2"
            color={selected ? "textSecondaryContrast" : "textSecondary"} 
            noWrap={true}
            textCustomProps={textCustomPropsSecondary}
          >
            {secondary}
          </Text>          
        </MuiBox>
      }
    </MuiBox>
  )
}

const _CardSubtitle = ({primary, textPrimaryColor, secondary, maxLine=4, selected}) => {
  return (
    <MuiBox display='flex' alignItems='center'>
      <MuiBox flexGrow={1}>
        <Text
          variant="body2"
          color={selected ? 
            "textPrimaryContrast" : 
            typeof textPrimaryColor !== 'undefined' ? textPrimaryColor : "textPrimary"
          }
          maxLine={maxLine}
        >
          {primary}
        </Text>
      </MuiBox>
      {secondary &&
        <MuiBox>
          <Text
            variant="body2"
            color={selected ? "textSecondaryContrast" : "textSecondary"} 
            noWrap={true}
          >
            {secondary}
          </Text>          
        </MuiBox>
      }
    </MuiBox>
  )
}

// `trailing` (a subtitle's secondary with no primary, see utils/cardLayout.js) sits at the right end of the row `trailingIndex`
const _CardBody = ({rows, selected, trailing, trailingIndex = -1}) => {
  const color = selected ? "textSecondaryContrast" : "textSecondary"

  return (
    <MuiBox>
      {rows.map((row, i) => {
        const text = (
          <Text
            key={i}
            variant="body2"
            maxLine={4}
            color={color}
          >
            {row}
          </Text>
        )

        if (i !== trailingIndex || !trailing) return text

        return (
          <MuiBox key={i} display='flex' alignItems='baseline'>
            <MuiBox flexGrow={1} minWidth={0}>{text}</MuiBox>
            <MuiBox>
              <Text variant="body2" color={color} noWrap={true}>
                {trailing}
              </Text>
            </MuiBox>
          </MuiBox>
        )
      })}
    </MuiBox>
  )
}

const _CardFooter = ({primary, textPrimaryColor, secondary, maxLine=4, selected}) => {
  const classes = useStyles()
  
  return (
    <>
      <div className={classes.separatorFooter} />
      <MuiBox display='flex' alignItems='center'>
        <MuiBox flexGrow={1}>
          <Text
            variant="body2"
            color={selected ? 
              "textPrimaryContrast" : 
              typeof textPrimaryColor !== 'undefined' ? textPrimaryColor : "textPrimary"
            }
            maxLine={maxLine}
          >
            {primary}
          </Text>
        </MuiBox>
        {secondary &&
          <MuiBox>
            <Text
              variant="body2"
              color={selected ? "textSecondaryContrast" : "textSecondary"} 
              noWrap={true}
            >
              {secondary}
            </Text>          
          </MuiBox>
        }
      </MuiBox>
    </>
  )
}

export const CardMedia = React.memo(_CardMedia)
export const CardTitle = React.memo(_CardTitle)
export const CardSubtitle = React.memo(_CardSubtitle)
export const CardFooter = React.memo(_CardFooter)
export const CardBody = React.memo(_CardBody)

export const Card = (props) => {    
  const classes = useStyles()
  const {selected, onClick, children, ...listItemProps} = props
  
  let media = []
  let contents = []
  React.Children.forEach(children, el => {    
    if (React.isValidElement(el) && el.type == CardMedia)
      media.push(el)
    else
      contents.push(el)
  })

  return (
    <ListItem onClick={onClick}
      component="li"
      selected={selected}
      primary={media.length > 0 && contents.length > 0 ?
        <MuiBox display='flex'>
          {media}
          <MuiBox ml={media.length > 0 ? 1 : 0} flexGrow={1}>
            {contents}
          </MuiBox>
        </MuiBox>
        :
        (media.length > 0 ? media : contents)
      }
      {...listItemProps}
      />
  )
}

// export const Card = React.memo(
//   _Card,
//   (prev, next) =>
//     prev.selected === next.selected &&
//     prev.children === next.children // children must be stable
// )

export default Card